var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M38.5178 40.5178C38.9866 40.0489 39.25 39.413 39.25 38.75V20.25C39.25 18.0409 37.4591 16.25 35.25 16.25H29.25C28.587 16.25 27.9511 15.9866 27.4822 15.5178C27.0134 15.0489 26.75 14.413 26.75 13.75V7.75C26.75 5.54086 24.9591 3.75 22.75 3.75H9.25C8.58696 3.75 7.95107 4.01339 7.48223 4.48223C7.01339 4.95107 6.75 5.58696 6.75 6.25V38.75C6.75 39.413 7.01339 40.0489 7.48223 40.5178C7.95107 40.9866 8.58696 41.25 9.25 41.25H36.75C37.413 41.25 38.0489 40.9866 38.5178 40.5178Z",
  fill: "#EBDDFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.25 36.75C36.25 37.413 35.9866 38.0489 35.5178 38.5178C35.0489 38.9866 34.413 39.25 33.75 39.25H6.25C5.58696 39.25 4.95107 38.9866 4.48223 38.5178C4.01339 38.0489 3.75 37.413 3.75 36.75V4.25C3.75 3.58696 4.01339 2.95107 4.48223 2.48223C4.95107 2.01339 5.58696 1.75 6.25 1.75H23.965C24.6276 1.75014 25.263 2.0133 25.7317 2.48167L35.5183 12.2683C35.9867 12.737 36.2499 13.3724 36.25 14.035V36.75Z",
  stroke: "#00002B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36.25 14.25H26.25C25.587 14.25 24.9511 13.9866 24.4822 13.5178C24.0134 13.0489 23.75 12.413 23.75 11.75V1.75",
  stroke: "#00002B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20 22H30",
  stroke: "#00002B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.25 33H30",
  stroke: "#00002B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M11.25 27.5H30",
  stroke: "#00002B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M9.25 17.6854V9.25",
  stroke: "#00002B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6242 17.6854L9.25 13.4677L12.6242 9.25",
  stroke: "#00002B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M14.876 17.6854V9.25",
  stroke: "#00002B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M14.874 9.25H16.1416C16.7009 9.25 17.2373 9.47218 17.6328 9.86767C18.0283 10.2632 18.2504 10.7995 18.2504 11.3589C18.2504 11.9182 18.0283 12.4545 17.6328 12.85C17.2373 13.2455 16.7009 13.4677 16.1416 13.4677H14.874",
  stroke: "#00002B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2503 17.6855L15.7197 13.4678",
  stroke: "#00002B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgTaxNoteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxNoteIcon);
export default __webpack_public_path__ + "static/media/TaxNoteIcon.1ad904cc80f030ffd27acd1580286d49.svg";
export { ForwardRef as ReactComponent };